import { AddressData } from './address.model';
import { ArtistData } from './artist.model';
import { OtherData } from './other.model';
import { SellerData } from './seller.model';
import { WorkData } from './work.model';
export enum DatabaseContentType {
  WORKS = 'works',
  ARTISTS = 'artists',
  COLLECTORS = 'collectors',
  SELLERS = 'sellers',
  OTHERS = 'others',
  ADDRESSES = 'addresses',
  EXHIBIT = 'exhibits',
}

export type AllFormsData = ArtistData | WorkData | OtherData | SellerData | AddressData;

// Minimal interface to describe artist, work... content
export interface FormContent {
  ID: string;
  [key: string]: any;
}

export interface DatabaseServiceCommon {
  getCollections: any; // Get list of items
  get: any; // Get one item
  post: any; // Create one item
  delete: any; // Delete one item
  rotate?: any; // Rotate an image
  upload?: any; // Optionaly upload file or image assoicated to an item
}
